const LocalCacheKey = {
  CONTRACT_LIST_MD5_KEY: "ct-symbols-md5-key",
  CONTRACT_LIST_DATA: "ct-symbols-data",
  CONTRACT_GRADIENT_MD5_KEY: "ct-gradient-md5-key",
  CONTRACT_GRADIENT_DATA: "ct-gradient-data",
  CONTRACT_IS_FUTURES_COUPON_MODE: "cointr:mix-isFuturesCouponMode",
  CONTRACT_IS_CREATION_DEMO_ACCOUNT: "cointr:mix-isCreationDemoAccount",

  // ========== 现货用的key
  SPOT_LIST_MD5_KEY: "spot_list_md5_key",
  SPOT_LIST_DATA: "spot_list_data",

  spot_isolated_config_md5: "spot_isolated_config_md5",
  spot_isolated_config_Md5_data: "spot_isolated_config_Md5_data",

  spot_cross_config_md5: "spot_cross_config_md5",
  spot_cross_config_md5_data: "spot_cross_config_md5_data",

  SPOT_PARTITION_MD5: "spot_partition_md5",
  SPOT_PARTITION_MD5_DATA: "spot_partition_md5_data",

  SPOT_ASSEST_MD5: "spot_assest_md5",
  SPOT_ASSEST_MD5_DATA: "spot_assest_md5_data",

  SPOT_CONVERT_LIST_MD5: "spot_convert_list_md5",
  SPOT_CONVERT_LIST_MD5_DATA: "spot_convert_list_md5_data",

  SPOT_MARGIN_LEVER_FIRST_ENTRY_TIPS_IS_SHOW:
    "spot_margin_lever_first_entry_tips_is_show",
  // ========== 现货用的key

  // 现货交易页面-仓位区域-资产tab,新功能提示tip
  SPOT_POSITION_ASSETS_CROSS_TIP: "spot_position_assets_cross_tip",
  // -----
  OLDER_USER_UID_TIPS: "shark:old_uid_tips", // UID
} as const;

export { LocalCacheKey };
